import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { B3DesignSystemWebModule } from '../shared/b3-design-system-web/b3-design-system-web.module';
import { DinamicTitleService } from '../services/title/dinamic-title.service';

import { B3TextareaComponent } from './b3-textarea/b3-textarea.component';

import { HeaderComponent } from './header/header.component';
import { MenuComponent } from './menu/menu.component';
import { SupportFaqAnswerComponent } from './menu/support-faq-answer/support-faq-answer.component';
import { PlatformHeaderComponent } from './platform-header/platform-header.component';
import { ConsultTableEmptyStateComponent } from './consult-table-empty-state/consult-table-empty-state.component';
import { ModalCarbonCreditDetailComponent } from './modal-carbon-credit-detail/modal-carbon-credit-detail.component';
import { ModalTransferenceSuccessComponent } from './modal-transference-success/modal-transference-success.component';
import { ModalTransferenceErrorComponent } from './modal-transference-error/modal-transference-error.component';
import { ModalConfirmationComponent } from './modal-confirmation/modal-confirmation.component';
import { ModalRetryRegisterComponent } from './modal-retry-register/modal-retry-register.component';
import { PsaStepGeneralDataComponent } from './steps-project-register/step-general-data/step-general-data.component';
import { PsaStepPropertyComponent } from './steps-project-register/step-property/step-property.component';
import { PsaStepMethodologyComponent } from './steps-project-register/step-methodology/step-methodology.component';
import { PsaStepCoBenefitsComponent } from './steps-project-register/step-coBenefits/step-coBenefits.component';
import { PsaStepConfirmationComponent } from './steps-project-register/step-confirmation/step-confirmation.component';
import { ModalProjectComponent } from './modal-project/modal-project.component';
import { ModalWithInputTextComponent } from './modal-with-input-text/modal-with-input-text.component';
import { AddOthersDevelopersComponent } from './psa-add-others-developers/psa-add-others-developers.component';
import { AddOthersOwnersComponent } from './psa-add-others-owners/psa-add-others-owners.component';
import { AddOthersLinksDocumentsComponent } from './psa-add-others-links-documents/psa-add-others-links-documents.component';
import { CheckboxGroupOdsComponent } from './psa-checkbox-group-ods/psa-checkbox-group-ods.component';
import { ComboUfCidadeComponent } from './combo-uf-cidade/combo-uf-cidade.component';
import { LoadingStateComponent } from './loading-state/loading-state.component';
import { FieldMessageComponent } from '../shared/components/field-message/field-message.component';
import { FieldHintPipe } from '../shared/pipes/field-hint.pipe';

@NgModule({
  declarations: [
    HeaderComponent,
    PlatformHeaderComponent,
    ConsultTableEmptyStateComponent,
    ModalCarbonCreditDetailComponent,
    ModalTransferenceSuccessComponent,
    ModalTransferenceErrorComponent,
    ModalConfirmationComponent,
    ModalRetryRegisterComponent,
    ModalProjectComponent,
    ModalWithInputTextComponent,
    MenuComponent,
    SupportFaqAnswerComponent,
    B3TextareaComponent,
    LoadingStateComponent,
    FieldMessageComponent,
    FieldHintPipe,

    PsaStepGeneralDataComponent,
    PsaStepPropertyComponent,
    PsaStepMethodologyComponent,
    PsaStepCoBenefitsComponent,
    PsaStepConfirmationComponent,

    AddOthersDevelopersComponent,
    AddOthersOwnersComponent,
    AddOthersLinksDocumentsComponent,
    CheckboxGroupOdsComponent,
    ComboUfCidadeComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    B3DesignSystemWebModule,
    ReactiveFormsModule
  ],
  providers: [
    { provide: DinamicTitleService }
  ],
  exports:[
    HeaderComponent,
    PlatformHeaderComponent,
    ConsultTableEmptyStateComponent,
    ModalCarbonCreditDetailComponent,
    ModalTransferenceSuccessComponent,
    ModalTransferenceErrorComponent,
    ModalConfirmationComponent,
    ModalRetryRegisterComponent,
    ModalProjectComponent,
    ModalWithInputTextComponent,
    MenuComponent,
    B3TextareaComponent,
    LoadingStateComponent,
    FieldMessageComponent,
    FieldHintPipe,

    PsaStepGeneralDataComponent,
    PsaStepPropertyComponent,
    PsaStepMethodologyComponent,
    PsaStepCoBenefitsComponent,
    PsaStepConfirmationComponent,

    AddOthersDevelopersComponent,
    AddOthersOwnersComponent,
    AddOthersLinksDocumentsComponent,
    CheckboxGroupOdsComponent,
    ComboUfCidadeComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule { }
